// What Ask AI filled in on the Stop Service page's link (Ben 2026-10-27, option 1
// on "Ask AI's close-this-building card skips Stop Service"; kept 2026-10-31).
//
// Ask AI never ends, pauses or resumes service from the chat. It opens this page
// with what the person said already filled in, and they check it and press the
// page's own button — the separation wizard's hand-off (TCSD-0532). The link is
// built by stopServiceFormLink in supabase/functions/am-copilot/buildings.ts;
// ask-ai-stop-service.test.ts runs both and fails on any difference.
//
// Reading the link saves nothing. Every value stays editable, and a value the
// page would not offer (a reason not on its list, a branch this person cannot
// take) is dropped rather than shown.

export interface StopServicePrefill {
  /** The page's branch: pause or terminate. Null = no branch (resume, or nothing said). */
  branch: 'pause' | 'terminate' | null;
  reasonCode: string;
  /** Pause: the expected resume date. Terminate: the final service date. */
  date: string;
  note: string;
}

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;
const day = (v: string | null) => (v && ISO_DAY.test(v) && !Number.isNaN(Date.parse(v)) ? v : '');

/** The prefill on the link, or null when the link carries none. */
export function readStopServicePrefill(params: URLSearchParams): StopServicePrefill | null {
  const b = params.get('branch');
  const branch = b === 'pause' || b === 'terminate' ? b : null;
  const reasonCode = (params.get('reason_code') ?? '').trim();
  const date = day(branch === 'pause' ? params.get('expected_resume_date') : branch === 'terminate' ? params.get('final_service_date') : null);
  const note = (params.get('note') ?? '').trim();
  if (!branch && !note) return null;
  return { branch, reasonCode, date, note };
}
